<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/contracts"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-11">
          <h4 v-if="contract != null">
            <u>Voucher : {{ contract.Voucher }}</u>
          </h4>
        </div>
      </div>
    </div>

    <div
      class="row"
      style="padding-top: 20px; padding-left: 20px"
      v-if="contract != null"
    >
      <form class="forms-style">
        <div class="row">
          <div class="col-md-6">
            <div class="panel-heading">Γενικά στοιχεία</div>
            <div class="panel panel-primary">
              <div class="panel-body">
                <div class="form-group">
                  <label for="id" class="col-sm-3 control-label">Voucher</label>
                  <input
                    type="text"
                    class="form-field"
                    id="Description"
                    v-model="contract.Voucher"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="fundingType" class="col-sm-3 control-label"
                    >Χρηματοδότηση</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="fundingType"
                    v-model="contract.FundingTypeDto.Description"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="contractCategory" class="col-sm-3 control-label"
                    >Τύπος σύμβασης</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="contractCategory"
                    v-model="contract.ContractCategoryDto.Description"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="signDate" class="col-sm-3 control-label"
                    >Ημερομηνία υπογραφής</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="signDate"
                    :value="contract.SignDate | formatDate"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="startDate" class="col-sm-3 control-label"
                    >Έναρξη</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="startDate"
                    :value="contract.StartDate | formatDate"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="endDate" class="col-sm-3 control-label"
                    >Λήξη</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="endDate"
                    :value="contract.EndDate | formatDate"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="amount" class="col-sm-3 control-label"
                    >Ποσό</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="amount"
                    v-model="contract.Amount"
                    readonly
                  />
                </div>
              </div>
            </div>

            <div class="panel-heading">Στοιχεία Ωφελούμενης/ου</div>
            <div class="panel panel-primary">
              <div class="panel-body">
                <div class="form-group">
                  <label for="fullName" class="col-sm-3 control-label"
                    >Ονοματεπώνυμο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="fullName"
                    v-model="this.kidFullName"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="birthDate" class="col-sm-3 control-label"
                    >Ημερ.Γέννησης</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="birthDate"
                    :value="contract.KidDto.BirthDate | formatDate"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="Amka" class="col-sm-3 control-label">ΑΜΚΑ</label>
                  <input
                    type="text"
                    class="form-field"
                    id="Amka"
                    v-model="contract.KidDto.Amka"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="afm" class="col-sm-3 control-label">ΑΦΜ</label>
                  <input
                    type="text"
                    class="form-field"
                    id="afm"
                    v-model="contract.KidDto.Afm"
                    readonly
                  />
                </div>
                <div v-if="isAdmin || isSuperAdmin" class="form-group">
                  <label for="barcode" class="col-sm-3 control-label"
                    >ΒarCode</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="barcode"
                    v-model="contract.Barcode"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="panel-heading">Στοιχεία Νόμιμου Εκπροσώπου</div>
            <div class="panel panel-primary">
              <div class="panel-body">
                <div class="form-group">
                  <label for="afm" class="col-sm-3 control-label">ΑΦΜ</label>
                  <input
                    type="text"
                    class="form-field"
                    id="afm"
                    v-model="contract.ParentDto.Afm"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="idNumber" class="col-sm-3 control-label"
                    >Αρ.Ταυτότητας</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="idNumber"
                    v-model="contract.ParentDto.IdNumber"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="amka" class="col-sm-3 control-label">AMKA</label>
                  <input
                    type="text"
                    class="form-field"
                    id="amka"
                    v-model="contract.ParentDto.Amka"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="parentFullName" class="col-sm-3 control-label"
                    >Ονοματεπώνυμο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="parentFullName"
                    v-model="this.parentFullName"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="fatherFullName" class="col-sm-3 control-label"
                    >Πατρώνυμο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="parentFullName"
                    v-model="this.fatherFullName"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="motherFullName" class="col-sm-3 control-label"
                    >Μητρώνυμο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="motherFullName"
                    v-model="this.motherFullName"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="birthDate" class="col-sm-3 control-label"
                    >Ημερ.Γέννησης</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="motherFullName"
                    :value="contract.ParentDto.BirthDate | formatDate"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="birthPlace" class="col-sm-3 control-label"
                    >Τόπος Γέννησης</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="birthPlace"
                    v-model="contract.ParentDto.BirthPlace"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="phoneNumber" class="col-sm-3 control-label"
                    >Τηλέφωνο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="phoneNumber"
                    v-model="contract.ParentDto.PhoneNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="cellPhoneNumber" class="col-sm-3 control-label"
                    >Κινητό</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="cellPhoneNumber"
                    v-model="contract.ParentDto.CellPhoneNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="workPhoneNumber" class="col-sm-3 control-label"
                    >Τηλέφωνο Εργασίας</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="workPhoneNumber"
                    v-model="contract.ParentDto.WorkPhoneNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="faxNumber" class="col-sm-3 control-label"
                    >Fax</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="faxNumber"
                    v-model="contract.ParentDto.FaxNumber"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="city" class="col-sm-3 control-label"
                    >Πόλη κατοικίας</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="city"
                    v-model="contract.ParentDto.City"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="streetName" class="col-sm-3 control-label"
                    >Διεύθυνση κατοικίας</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="streetName"
                    v-model="contract.ParentDto.StreetName"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="streetNum" class="col-sm-3 control-label"
                    >Αριθμός</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="streetNum"
                    v-model="contract.ParentDto.StreetNum"
                    readonly
                  />
                </div>
                <div class="form-group">
                  <label for="ZipCode" class="col-sm-3 control-label"
                    >Ταχ.Κώδικας</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="ZipCode"
                    v-model="contract.ParentDto.ZipCode"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";

import BackButton from "../../components/shared/backButton";

export default {
  props: ["cId"],
  components: {
    BackButton,
  },
  data() {
    return {
      contract: null,
    };
  },
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    kidFullName() {
      return (
        (this.contract.KidDto.LastName != null
          ? this.contract.KidDto.LastName
          : "") +
        " " +
        (this.contract.KidDto.FirstName != null
          ? this.contract.KidDto.FirstName
          : "")
      );
    },
    parentFullName() {
      return (
        (this.contract.ParentDto.LastName != null
          ? this.contract.ParentDto.LastName
          : "") +
        " " +
        (this.contract.ParentDto.FirstName != null
          ? this.contract.ParentDto.FirstName
          : "")
      );
    },
    fatherFullName() {
      return (
        (this.contract.ParentDto.FatherLastName != null
          ? this.contract.ParentDto.FatherLastName
          : "") +
        " " +
        (this.contract.ParentDto.FatherFirstName != null
          ? this.contract.ParentDto.FatherFirstName
          : "")
      );
    },
    motherFullName() {
      return (
        (this.contract.ParentDto.MotherLastName != null
          ? this.contract.ParentDto.MotherLastName
          : "") +
        " " +
        (this.contract.ParentDto.MotherFirstName != null
          ? this.contract.ParentDto.MotherFirstName
          : "")
      );
    },
  },
  methods: {},

  async mounted() {
    
    const res = await mainService.get(
      `/contracts/GetContractById?id=${this.cId}&organizationId=${this.organizationId}`
    );
    this.contract = res.data;
  },
};
</script>

<style lang="scss" scoped>
.forms-style label {
  width: 175px;
}
</style>